import styled from 'styled-components'

export const StyledHeader = styled.div`
  display: flex;
  width: 100%;
  height: 20%;
  flex-direction: column;
  justify-content: center;

  @media screen and (max-width: 812px) {
    height: 185px;
    margin: 1em 0 1em 0;
  }
`

export const Navigation = styled.div`
  display: flex;
  width: 100%;
  height: 70%;
  padding-top: 1.75em;
  justify-content: center;

  @media screen and (max-width: 812px) {
    flex-direction: column;
    align-items: center;
    padding-top: 0;
  }
`

export const Title = styled.div`
  position: relative;

  display: block;
  width: 100%;
  height: 30%;

  &::before{
    position: absolute;
    left: 50%;
    bottom: 12%;
    margin-right: -50%;
    transform: translate(-50%, -50%);

    display: block;
    height: 3px;
    width: 94%;

    content: "";
    background: #FFF;
    border-radius: 5px;

    @media screen and (max-width: 812px) {
      height: 2px;
    }
  }

  @media screen and (max-width: 812px) {
    margin-top: 1em;
    height: 15%;
  }
`

export const GrandPrix = styled.p`
  position: absolute;
  bottom: 50%;
  left: 3%;

  display: block;

  font-family: 'Crash';
  font-size: 1.75em;
  transform: scaleX(0.85);
  transform-origin: 0;
  letter-spacing: -.025em;

  @media screen and (max-width: 812px) {
    font-size: 1.35em;
  }
`

export const TimeRemaining = styled.p`
  position: absolute;
  bottom: 50%;
  right: 3%;

  display: block;
  
  font-family: 'Barthowheel-Regular';
  font-size: 1.15em;

  @media screen and (max-width: 812px) {
    font-size: 0.85em;
  }
`

export const MusicToggle = styled.div`
  position: absolute;
  bottom: 25%;
  right: 3%;

  display: block;
  font-size: 1.5em;
`